const StarIcon = (props) => (
<svg {...props} viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.60867 11.84L2.90667 14.472L3.95667 9.18667L0 5.528L5.35133 4.89333L7.60867 0L9.866 4.89333L15.2173 5.528L11.2607 9.18667L12.3107 14.472L7.60867 11.84Z" fill={props.fill ?? "#616778"}/>
</svg>

);

export default StarIcon;
